// extracted by mini-css-extract-plugin
module.exports = {"head":"Promocodes_head__1QUJB","spacebetween":"Promocodes_spacebetween__1Y_cv","leftmargin":"Promocodes_leftmargin__2Yvv7","itemlist":"Promocodes_itemlist__hp5Em"};